import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import Users from "@/views/Users.vue";
import Default from "@/views/Default.vue";
import Services from "@/views/Services.vue";
import Dashboard from "@/views/Dashboard.vue";
import Authentication from "@/views/Authentication.vue";
import Reports from "@/views/Reports.vue";
import Transactions from "@/views/Transactions.vue";
import Gateways from "@/views/Gateways.vue";
import Settings from "@/views/Settings.vue";
import GatewayTransactions from "@/views/GatewayTransactions.vue";
import GatewaySettings from "@/views/GatewaySettings.vue";
import UserExternalTransactions from "@/views/UserExternalTransactions.vue";
import UserWithdrawals from "@/views/UserWithdrawals.vue";
import ManualCharges from "@/views/ManualCharges.vue";
import PlatformLogs from "@/views/PlatformLogs.vue";
import WithdrawalsCrypto from "@/views/WithdrawalsCrypto.vue";
import Notifications from "@/views/Notifications.vue";
import Exchange from "@/views/Exchange.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Default",
        component: Default,
        children: [
            {
                path: "authentication",
                name: "Authentication",
                component: Authentication,
            },
            {
                path: "panel",
                name: "Dashboard",
                component: Dashboard,
                children: [
                    {
                        path: "/panel",
                        name: "Services",
                        component: Services
                    },
                    {
                        path: "users",
                        name: "Users",
                        component: Users
                    },
                    {
                        path: "reports",
                        name: "Reports",
                        component: Reports
                    },
                    {
                        path: "platform-logs",
                        name: "platform-logs",
                        component: PlatformLogs
                    },
                    {
                        path: "transactions",
                        name: "Transactions",
                        component: Transactions
                    },
                    {
                        path: "manual-charges",
                        name: "ManualCharges",
                        component: ManualCharges
                    },
                    {
                        path: "platform-logs",
                        name: "PlatformLogs",
                        component: PlatformLogs
                    },
                    {
                        path: "gateways",
                        name: "Gateways",
                        component: Gateways
                    },
                    {
                        path: "settings",
                        name: "Settings",
                        component: Settings
                    },
                    {
                        path: "gateway-transactions",
                        name: "GatewayTransactions",
                        component: GatewayTransactions
                    },
                    {
                        path: "gateway-settings",
                        name: "GatewaySettings",
                        component: GatewaySettings
                    },
                    {
                        path: "user-transactions",
                        name: "UserTransactions",
                        component: UserExternalTransactions
                    },
                    {
                        path: "user-withdrawals",
                        name: "UserWithdrawals",
                        component: UserWithdrawals
                    },
                    {
                        path: "exchange",
                        name: "Exchange",
                        component: Exchange
                    },
                    // {
                    //     path: "withdrawals-crypto",
                    //     name: "WithdrawalsCrypto",
                    //     component: WithdrawalsCrypto
                    // },
                    {
                        path: "notificaions",
                        name: "Notifications",
                        component: Notifications
                    },
                ]
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    // reset global pagination
    store.dispatch('panel/resetGlobalPagination');
    next();
})

export default router;
